<template>
  <div>
    <div class="">
      <el-input
        size="small"
        v-model="formData.sclass_id"
        placeholder="关联赛事id(例36,34,8)(选填)"
      ></el-input>
      <el-input
        size="small"
        v-model="formData.team_id"
        placeholder="关联球队id(例25,27,84,9)(选填)"
      ></el-input>
      <el-input
        size="small"
        v-model="formData.public_date"
        placeholder="发布日期(选填) (格式2019-12-10)"
      ></el-input>
      <el-button type="primary" size="mini" @click="confirm">确定</el-button>
    </div>

    <div style="overflow-y: hidden">
      <div
        class="information_box"
        v-infinite-scroll="load"
        style="overflow: auto"
      >
        <el-card v-for="(item, index) in news_l" :key="index">
          <div class="information" @click="fnJumpDetailsPage(item.news_id)">
            <div class="information_l">
              <img
                src="https://ns-strategy.cdn.bcebos.com/ns-strategy/upload/fc_big_pic/part-00575-1308.jpg"
              />
            </div>
            <div class="information_r">
              <h3>{{ item.title }}</h3>
              <p class="conter_s" v-html="item.content"></p>
              <p class="pp">
                <span>{{ item.public_time }}({{ item.reprinted }})</span>
                <span class="pp_span">
                  <!-- <span><i class="el-icon-s-promotion"></i>转发</span>
                  <span><i class="el-icon-star-on"></i>收藏</span> -->
                </span>
              </p>
            </div>
          </div>
        </el-card>
        <p v-if="loading" class="loading">加载中...</p>
        <p v-if="noMore" class="loading">没有更多了</p>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, getCurrentInstance, reactive } from 'vue'
import { useRouter } from 'vue-router'
export default {
  props: ['AUTH_OBJ', 'token'],
  setup(props) {
    console.log(props.AUTH_OBJ)
    let { proxy: _this } = getCurrentInstance()
    let router = useRouter()
    let formData = reactive({
      public_date: '',
      sclass_id: '',
      team_id: '',
      page: 1
    })
    // 初始全部新闻
    let news_l = ref([])
    let loading = ref(true)
    let noMore = ref(false)
    let soccer_news = async () => {
      !formData.sclass_id ? delete formData.sclass_id : ''
      !formData.team_id ? delete formData.team_id : ''
      !formData.public_date ? delete formData.public_date : ''
      try {
        let { data: res } = await _this.$http.get(`/auth/user/news_list`, {
          params: formData
        })
        res.data.forEach((item) => {
          item.content = item.content
            .replace(/href/g, 'aaa')
            .replace(/img src=/g, 'aaa')
        })
        news_l.value = news_l.value.concat(...res.data)
        if (res.data.length === 0) {
          loading.value = false
          noMore.value = true
          _this.$notify({
            title: '提示',
            message: '已加载全部内容',
            type: 'error'
          })
        }
      } catch (error) {
        // console.log(error.response)
      }
    }
    // 无限滚动
    const load = () => {
      soccer_news()
      formData.page++
    }
    // 跳转详情页
    let fnJumpDetailsPage = (new_id) => {
      let routeUrl = router.resolve({
        path: `/new/detail/${new_id}`
      })
      window.open(routeUrl.href, '_blank')
    }
    // 条件赛选
    let confirm = () => {
      formData.page = 1
      news_l.value = []
      load()
    }
    return {
      formData,
      news_l,
      fnJumpDetailsPage,
      load,
      loading,
      noMore,
      confirm
    }
  }
}
</script>
<style scoped lang="less">
.el-card {
  margin: 10px 0;
  .information {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .information_l {
      width: 12%;
      height: 100px;
      border-radius: 10px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .information_r {
      width: 83%;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      h3 {
        font-weight: 600;
      }
      .conter_s {
        height: 20px;
        overflow: hidden;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 1; /**显示的行数**/
        padding: 10px;
        line-height: 26px;
        background: #eee;
      }
    }
  }
  .pp {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #8c8c8c;
    font-weight: 600;
    .pp_span {
      span {
        margin: 0 10px;
      }
    }
  }
}
.information_box::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}
.information_box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.information_box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.information_box {
  height: 600px;
}
.loading {
  color: #8c8c8c;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.el-input {
  width: 250px;
}
</style>
